<div class="container">
  <div class="header-container">
    <h1>{{ title() }}</h1>
    @if (infoTooltipText()) {
      <button
        mat-icon-button
        [matTooltip]="infoTooltipText()"
        matTooltipPosition="above"
        #tooltip="matTooltip"
        aria-label="Info"
        (click)="tooltip.toggle()"
      >
        <mat-icon>info_outline</mat-icon>
      </button>
    }
  </div>
  <div class="advice-card-content">
    <ng-content></ng-content>
  </div>
</div>
